import React from 'react';

class CheckoutAgreement extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            id,
            accountAgreement,
            accountAgreementText,
            changeAccountAgreement,
            resourcedTexts,
        } = this.props;

        return (
            <div className={`checkout-agreement form-field checkbox-single ${accountAgreement ? '' : 'is-invalid'}`}>
                <input id={id} type="checkbox" required onChange={changeAccountAgreement}/>
                <label htmlFor={id}><span
                    dangerouslySetInnerHTML={{__html: accountAgreementText}}/></label>
                <span className={`field-validation-error`}>{resourcedTexts.inputErrorMessageDefault}</span>
            </div>
        )
    }
}

export {CheckoutAgreement}